import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {ProductPort} from '@features/product/application/ports/product.port';
import {ProductHttpAdapter} from '@features/product/infrastructure/http/product.http.adapter';
import {QueryHttpService} from '@shared/infrastructure/http/services/query-http.service';

export const ProductHttpAdapterProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  QueryHttpService,
  {
    provide: ProductPort,
    useClass: ProductHttpAdapter
  }
];
